const setCookie = (
    name: string,
    value: string,
    options: { [key: string]: any } = {},
) => {
    let { expirationDays } = options;
    let expires;

    if (typeof expirationDays === 'number' && expirationDays) {
        let d = new Date();
        d.setTime(d.getTime() + expirationDays * 24 * 60 * 60 * 1000);
        expires = d;
        delete options.expirationDays;
    }

    if (expires && expires.toUTCString) {
        options.expires = expires.toUTCString();
    }

    value = encodeURIComponent(value);

    let updatedCookie = `${name}=${value}`;

    for (const propName in options) {
        if (Object.prototype.hasOwnProperty.call(options, propName)) {
            updatedCookie += `;${propName}=${options[propName]}`;
        }
    }

    updatedCookie += `;domain=.landr.com;path=/`;

    document.cookie = updatedCookie;
};

const deleteCookie = (name: string) => {
    setCookie(name, '', {
        expires: -1,
        'Max-Age': -1,
    });
};

const getCookie = (name: string) => {
    const matches = document.cookie.match(
        new RegExp(
            `(?:^|; )${name.replace(
                // eslint-disable-next-line no-useless-escape
                /([\.$?*|{}\(\)\[\]\\\/\+^])/g,
                '\\$1',
            )}=([^;]*)`,
        ),
    );

    if (matches) {
        try {
            return JSON.parse(decodeURIComponent(matches[1]));
        } catch (error) {
            return decodeURIComponent(matches[1]);
        }
    }

    return '';
};

export { getCookie, deleteCookie, setCookie };
